var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-order-promo",on:{"click":_vm.onGoProfilePromocode}},[_c('img',{staticClass:"profile-order-promo__img",attrs:{"src":require("@/assets/img/valentine_modal.jpg"),"alt":"promo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }